var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-overlay",
      class: { active: _vm.searchOpen },
      on: { click: _vm.close }
    },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.searchOpen
          ? _c(
              "div",
              { staticClass: "search-wrapper", class: _vm.activeScreen },
              [
                _c(
                  "form",
                  {
                    class: _vm.formClasses,
                    attrs: { id: "search-form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.performSearch()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "search-field" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "16px",
                            height: "16px",
                            viewBox: "0 0 18 20",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Search-/-Explore",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Main---New-Nav",
                                    transform:
                                      "translate(-108.000000, -746.000000)",
                                    "stroke-width": "1.2"
                                  }
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Group-3",
                                        transform:
                                          "translate(109.000000, 747.000000)"
                                      }
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          id: "Oval",
                                          cx: "6.8",
                                          cy: "6.8",
                                          r: "6.8"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("line", {
                                        attrs: {
                                          x1: "11.2",
                                          y1: "12",
                                          x2: "16",
                                          y2: "17.6",
                                          id: "Line-8",
                                          "stroke-linecap": "round"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchInput,
                            expression: "searchInput"
                          }
                        ],
                        attrs: { type: "text", placeholder: "Search" },
                        domProps: { value: _vm.searchInput },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchInput = $event.target.value
                            },
                            function($event) {
                              return _vm.handleInputChange()
                            }
                          ],
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return $event.target.blur()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.brandFilter.product_brand_id ||
                              _vm.brandFilter.affiliate_id,
                            expression:
                              "brandFilter.product_brand_id || brandFilter.affiliate_id"
                          }
                        ],
                        staticClass: "active-brand"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.brandFilter.product_brand_title ||
                                _vm.brandFilter.affiliate_title
                            ) +
                            " (" +
                            _vm._s(_vm.searchResult.total) +
                            "\n                    products)\n                    "
                        ),
                        _c("a", {
                          staticClass: "cross",
                          on: {
                            click: function($event) {
                              return _vm.searchByBrand({})
                            }
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.activeScreen == "search-result"
                  ? _c("full-view-select", {
                      attrs: {
                        options: _vm.sortOptions,
                        optionSelectedIndex: _vm.sortOptionSelected.index,
                        defaultValueText: "Sort By",
                        optionTextField: "title"
                      },
                      on: {
                        "option-changed": _vm.setSortOption,
                        closed: function() {
                          return _vm.setSortOption(null, null)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showBackButton
                  ? _c("div", { staticClass: "wtw-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "stay-black back-to-search-index",
                          on: { click: _vm.goBack }
                        },
                        [_vm._v("Back")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "searchContent",
                    staticClass: "search-content",
                    attrs: { id: "searchContent", "infinite-wrapper": "" }
                  },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.dataLoading && _vm.activeScreen == "search-result"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "loading-overlay" },
                              [_c("loader")],
                              1
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.activeScreen == "search-landing"
                      ? _c("search-landing", {
                          attrs: {
                            handleOnBrandClick: _vm.searchByBrand,
                            handleOnCollectionClick: _vm.goToCollectionView,
                            handleCtaClick: _vm.goToBrandsList,
                            brands: _vm.productBrands.filter(function(brand) {
                              return brand.product_brand_is_featured == 1
                            }),
                            collections: _vm.featuredCollections
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeScreen == "brands-list"
                      ? _c("brands-list", {
                          attrs: {
                            handleOnClick: _vm.searchByBrand,
                            brands: _vm.productBrands
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeScreen == "search-result"
                      ? _c("search-result-products", {
                          ref: "searchResult",
                          attrs: {
                            products: _vm.searchResult.products,
                            handleOnClick: _vm.goToProduct,
                            performSearch: _vm.performSearch,
                            setSortOption: _vm.setSortOption
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeScreen == "product-view"
                      ? _c("product-single-container", {
                          attrs: {
                            productId: _vm.currentProductId,
                            goBack: _vm.goToSearchResult
                          },
                          on: {
                            change: function(newProductId) {
                              return (_vm.currentProductId = newProductId)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19c2e88f", { render: render, staticRenderFns: staticRenderFns })
  }
}